import React, { Component } from 'react';
import screensaverConfig from '../../screensaverConfig.js';

import './screensaver.scss';

export class Screensaver extends Component {
    constructor(props) {
        super(props);
        this.state = { mounted: false };
    }

    componentDidMount() {
        // The setTimeout in componentDidMount is necessary
        // it defers setting the state until after the mount has happened.
        setTimeout(() => {
            this.setState({ mounted: true });
        }, 0);
    }

    render() {
        const { mounted } = this.state
        return (
            <div className={`screensaver ${mounted && 'animateIn'}`}>
                <video
                    autoPlay={screensaverConfig.autoPlay}
                    muted
                    loop={screensaverConfig.loop}
                    controls={screensaverConfig.controls}
                >
                    <source src={screensaverConfig.videoFile} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        );
    }
}

export default Screensaver;
